'use client';

import { LinkPlugin } from '@platejs/link/react';
import { LinkRules } from '@platejs/link';

import { LinkElement } from "../../ui/link-node";
import { LinkFloatingToolbar } from "../../ui/link-toolbar";

export const LinkKit = [
  LinkPlugin.configure({
    render: {
      node: LinkElement,
      afterEditable: () => <LinkFloatingToolbar />,
    },
    inputRules: [
      LinkRules.markdown(),
      LinkRules.autolink({ variant: 'paste' }),
      LinkRules.autolink({ variant: 'space' }),
      LinkRules.autolink({ variant: 'break' }),
    ],
  }),
];
